/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'PLAYERLIST': {
    width: 15,
    height: 15,
    viewBox: '0 0 15 15',
    data: '<g _fill="#2B2D53" fill-rule="nonzero"><path pid="0" d="M12.25.25H9.5a2 2 0 0 1-4 0H2.75l-2.5 2.5v3h2.5v9h9.5v-9h2.5v-3l-2.5-2.5zm-1 5.252L10.5 6l-.75-.528V4.5h1.5v1.002z" fill-opacity=".654"/><path pid="1" d="M14.927 2.573l-2.5-2.5A.25.25 0 0 0 12.25 0h-9.5a.25.25 0 0 0-.177.073l-2.5 2.5A.25.25 0 0 0 0 2.75v4c0 .138.112.25.25.25H2.5v7.75c0 .138.112.25.25.25h9.5a.25.25 0 0 0 .25-.25V7h2.25a.25.25 0 0 0 .25-.25v-4a.25.25 0 0 0-.073-.177zM9.23.5a1.748 1.748 0 0 1-3.46 0h3.46zM.5 6.5V6h2v.5h-2zm11.5 8H3V3.75h-.5V5.5h-2V2.853L2.853.5h.397v.75h.5V.5h.5v.75h.5V.5h.515a2.25 2.25 0 0 0 4.47 0h.515v.75h.5V.5h.5v.75h.5V.5h.396L14.5 2.853V5.5h-2V3.75H12V14.5zm2.5-8h-2V6h2v.5z"/><path pid="2" d="M11.25 4.25h-1.5a.25.25 0 0 0-.25.25v.972c0 .082.04.158.106.205l.75.528a.25.25 0 0 0 .282.003l.75-.498a.25.25 0 0 0 .112-.208V4.5a.25.25 0 0 0-.25-.25zM11 5.368l-.496.33L10 5.341V4.75h1v.618zM10.25 3.5h.504v.504h-.504zM11 3.5h.504v.504H11zM9.5 3.5h.504v.504H9.5z"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/PLAYERLIST.js